export enum Theme {
    Compact = 'compact',
    Comfortable = 'comfortable',
}
